import {
  Component, Output, EventEmitter, Input,
} from '@angular/core';
import { CourseFilter } from '../../courseFilter';

@Component({
  selector: 'app-course-categories-filters',
  templateUrl: './course-categories-filters.component.html',
  styleUrls: [ './course-categories-filters.component.scss' ],
})
export class CourseCategoriesFiltersComponent {
  @Input() mainFilter: CourseFilter;
  @Input() categoryList: any;
  @Output() updateMainFilter = new EventEmitter<object>();

  constructor() { }

  checkIncludesCategory(cat: any) {
    return !!this.mainFilter.categories.find((categoryItem: any) => cat.id === categoryItem.id);
  }

  updateCheckboxFilter(event: any, category: any): void {
    const isChecked = event?.target?.checked;

    if (isChecked) {
      this.mainFilter.categories.push(category);
    } else {
      this.mainFilter.categories = this.mainFilter.categories.filter((cat: any) => cat.id !== category.id);
    }
  }

  selectAllCategoriesFilter(event: any): void {
    if (event.target.checked) {
      this.mainFilter.categories = this.categoryList;
    } else {
      this.mainFilter.categories = [];
    }
  }

  clearCategoriesFilter(): void {
    this.mainFilter.categories = [];
  }

  getCategoryHelpText(category: any): string {
    // If the category has a description, use it
    if (category?.description) {
      return category.description;
    }

    // If the category has additional info, use it
    if (category?.additionalInfo) {
      return category.additionalInfo;
    }

    // If the category has details, use them
    if (category?.details) {
      return category.details;
    }

    // If the category has a type, provide context
    if (category?.type) {
      return `Show courses that belong to the ${category.type} category: ${category.category}`;
    }

    // If the category has a color or identifier, mention it
    if (category?.color) {
      return `Show courses in the ${category.category} category (${category.color})`;
    }

    // Default fallback with category name
    return `Show courses that belong to the ${category?.category} category`;
  }

}
